// extracted by mini-css-extract-plugin
export default {"container":"snTOe","fullDivider":"rJKrY","divider":"XKT7X"};